import { Renderer } from "../renderers/renderer"
import { AddButton as Button } from "../../add-button"

export class ConditionRenderer extends Renderer {
  constructor(node) {
    super(node)
    if (node.dataset.detail) {
      Object.defineProperty(this, "detail", {
        value: JSON.parse(node.dataset.detail)
      })
    }
  }

  get buttons() {
    if (this.node.dataset.split_path === "true") {
      return this.buttonsForPaths()
    } else {
      return this.buttonsForCondition()
    }
  }

  buttonsForCondition() {
    return ["yes", "no"].map(condition => {
      const button = new Button()
      button.dataset.condition = condition

      return button
    })
  }

  buttonsForPaths() {
    const pathsButtons = this.detail.matches_paths.map(({ id }) => {
      const button = new Button()
      button.dataset.condition_path = id
      button.dataset.split_path = true

      return button
    })

    const button = new Button()
    button.dataset.condition_path = "true"
    button.dataset.split_path = true

    return [...pathsButtons, button]
  }

  get text() {
    if (!this.node || !this.detail) {
      return ""
    } else {
      const dataset = this.node.dataset
      const detail = this.detail

      switch (dataset.type) {
        case "has-tag":
          return `Has <span>${dataset.name}</span> Tag`
        case "has-subscriber-filter":
          return `Matches Advanced Filter`
        case "has-custom-field":
          switch (detail.custom_field_kind) {
            case "blank":
              return `Has blank Custom field <span>${dataset.name}</span>`
            case "matches":
              return `Has Custom field <span>${dataset.name}</span> that matches <span>${detail.custom_field_value}</span>`
            case "contains":
              return `Has Custom field <span>${dataset.name}</span> that contains <span>${detail.custom_field_value}</span>`
            case "greater_than":
              return `Has Custom field <span>${dataset.name}</span> greater than <span>${detail.custom_field_value}</span>`
            case "greater_than_or_equal":
              return `Has Custom field <span>${dataset.name}</span> greater than or equal to <span>${detail.custom_field_value}</span>`
            case "less_than":
              return `Has Custom field <span>${dataset.name}</span> less than <span>${detail.custom_field_value}</span>`
            case "less_than_or_equal":
              return `Has Custom field <span>${dataset.name}</span> less than or equal to <span>${detail.custom_field_value}<span>`
            default:
              return `Has Custom field <span>${dataset.name}</span>`
          }
        case "has-opened-email":
          return "Has Opened an Email"
        case "matches-tag":
          return "Matches Tags"
        case "matches-custom-field":
          return "Matches Custom Field"
      }
    }
  }

  get tooltipText() {
    if (!this.node || !this.node.detail || this.node.disabled) {
      return ""
    } else {
      const dataset = this.node.dataset
      const detail = this.node.detail

      switch (dataset.type) {
        case "has-tag":
          return `Check if the subscriber has the <b>${dataset.name}</b> tag`
        case "has-subscriber-filter":
          return `Check if the subscriber matches an advanced filter`
        case "has-custom-field":
          switch (detail.custom_field_kind) {
            case "blank":
              return `Check if the subscriber has the custom field <b>${dataset.name}</b> with a blank value or does not have the custom field`
            case "matches":
              return `Check if the subscriber has the custom field <b>${dataset.name}</b> and it matches <b>${detail.custom_field_value}</b>`
            case "contains":
              return `Check if the subscriber has the custom field <b>${dataset.name}</b> and it contains <b>${detail.custom_field_value}</b>`
            case "greater_than":
              return `Check if the subscriber has the custom field <b>${dataset.name}</b> and it is greater than <b>${detail.custom_field_value}</b>`
            case "greater_than_or_equal":
              return `Check if the subscriber has the custom field <b>${dataset.name}</b> and it is greater than or equal to <b>${detail.custom_field_value}</b>`
            case "less_than":
              return `Check if the subscriber has the custom field <b>${dataset.name}</b> and it is less than <b>${detail.custom_field_value}</b>`
            case "less_than_or_equal":
              return `Check if the subscriber has the custom field <b>${dataset.name}</b> and it is less than or equal to <b>${detail.custom_field_value}</b>`
            default:
              return `Check if the subscriber has the custom field <b>${dataset.name}</b> with any content`
          }
        case "has-opened-email":
          return "Has Opened an Email"
        case "matches-custom-field":
          return "Route the subscriber based on their custom field value"
        case "matches-tag":
          return "Route the subscriber based on which tags they have"
      }
    }
  }

  render() {
    if (this.node.dataset.split_path === "true") {
      this.renderPathLabels()
    } else {
      this.renderConditionLabels()
    }
  }

  renderConditionLabels() {
    const yesLabel = this.node
      .template("Workflow/Graph", "span[data-condition='true']")
      .cloneNode(true)
    yesLabel.dataset.condition = "yes"
    yesLabel.innerHTML = "Yes"

    this.node.appendChild(yesLabel)

    const noLabel = this.node
      .template("Workflow/Graph", "span[data-condition='true']")
      .cloneNode(true)
    noLabel.dataset.condition = "no"
    noLabel.innerHTML = "No"

    this.node.appendChild(noLabel)
  }

  renderPathLabels() {
    this.detail.matches_paths.map(({ id, label }) => {
      const pathLabel = this.node
        .template("Workflow/Graph", "span[data-condition='true']")
        .cloneNode(true)
      pathLabel.dataset.condition_path = id
      pathLabel.dataset.split_path = true
      pathLabel.innerHTML = label

      this.node.appendChild(pathLabel)
    })

    const defaultLabel = this.node
      .template("Workflow/Graph", "span[data-condition='true']")
      .cloneNode(true)
    defaultLabel.dataset.condition_path = "true"
    defaultLabel.dataset.split_path = true
    defaultLabel.innerHTML = "Everyone else"

    this.node.appendChild(defaultLabel)
  }
}
